export const DLink = ({ href, children }: { href: string; children: any }) => {
    return (
        <a href={href} style={{ textDecoration: "none", color: "white" }}>
            {children}
        </a>
    );
};